import { render } from "./SessionsComponent.vue?vue&type=template&id=644e2650"
import script from "./SessionsComponent.vue?vue&type=script&lang=js"
export * from "./SessionsComponent.vue?vue&type=script&lang=js"

import "./SessionsComponent.vue?vue&type=style&index=0&id=644e2650&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__